import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/arrow_success.png'
import _imports_1 from '@/assets/images/arrow_default.png'


const _withScopeId = n => (_pushScopeId("data-v-c8ccc074"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("上传LOGO")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("上传开票资料")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("上传营业执照")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存修改")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("添加英文名")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("有效")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("添加账户信息")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("自定义排序")
const _hoisted_15 = { style: {"white-space":"pre-wrap"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("有效")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("无效")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("默认")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("设为默认")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("选择文件")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 2,
  class: "arrow-disabled",
  src: _imports_1,
  alt: ""
}
const _hoisted_36 = {
  key: 3,
  class: "arrow-disabled arrow-down",
  src: _imports_1,
  alt: ""
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("保存")

  
const __default__ = {
  name: 'CompanyDetail'
}
import {ref, reactive, computed, onBeforeMount, nextTick} from 'vue'
import {ElMessage, ElMessageBox, genFileId} from 'element-plus'
import store from "@/store/index";
import { exportHandle } from '@/utils/index'
import router from '@/router/index'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import Api from '@/http/modules/index'
type CompanyEnRow = {
  id: number
  companyId: number
  enName: string
  enabled: boolean | null
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {
  // 修改公司基本信息
  'PATCH/companies': companiesPatchApi,
  // 发票主体公司列表
  'GET/companies/enNames/{id}': companiesEn_nameApi,
  // 新增（修改）公司英文名
  'POST/companies/en/create': companiesEncreateApi,
  // 删除英文名
  'DELETE/companies/enNames/{id}': delEnNamesApi,
  // 获取所有公司
  'GET/company': companyApi,
  // 获取一家公司详情
  'GET/companies/{id}': companiesDeatilsApi,
  // 获取公司账户信息
  'GET/company/bank_accounts/{id}': bank_accountsApi,
  // 新增或更新公司银行账号信息
  'POST/company/bank_account': bank_accountPostApi,
  // 删除公司账户信息
  'DELETE/company/bank_accounts/{id}': bank_accountsDelApi,
  // 上传公司账户文件
  'POST/company/bank_account/upload': bank_accountUploadApi,
  // 删除公司账户文件
  'POST/company/bank_account/delete': bank_accountDelApi,
  // 下载公司账户文件
  'POST/company/bank_account/download': bank_accountDownApi,
  // 设为默认银行
  'PUT/company/bank_account/priority': priorityApi,
  // 国别列表
  'GET/order/receivable/clients/countries': countriesListApi,
  // 下载营业执照或开票资料
  'GET/upload/download_file': download_fileApi,
  // 银行账户自定义排序
  'POST/company/bank_account/sort':bankAccountSortApi
} = Api
let {currencyOption} = PaymentModuleUtils

const activeName = ref('baseInfo')
const tableLoad = ref<boolean>(false)
const currentCpyId = computed(() => Number(router.currentRoute.value.params.id))
// ----------------基本信息模块---------------- 
// 公司基本信息
// const allCompany = ref([])
const baseInfoEle = ref()
const baseInfoForm: any = reactive({
  name: '',
  alias: '',
  minStandard: undefined,
  sort: undefined,
  domestic: '',
  status: '',
  pid: '',
  accountBookCode: '',
  companyCode: '',
  registeredAddress: '',
  registeredAddressAlias: '',
  logoFiles: [],
  invoiceFile: [],
  licenseFile: [],
  telephone: '',
  bankName: '',
  bankAccount: '',
})

const countrieList = ref([])
onBeforeMount(() => {
  initCompany()
  countriesListApi().then((rep: any) => {
    countrieList.value = rep
  })
  if(router.currentRoute.value.query?.type === 'account'){
    activeName.value = 'account'
  }
})

const initCompany = () => {
  tableLoad.value = true
  companiesDeatilsApi({id: currentCpyId.value}).then((rep: any) => {

    Object.assign(baseInfoForm, rep, {
      logoFiles: [{name: rep.logo, url: rep.logoUrl}],
      invoiceFile: rep.invoiceInfoFile ? [{name: rep.invoiceInfoFileName}] : [],
      licenseFile: rep.businessLicenseFile ? [{name: rep.businessLicenseFileName}] : [],
      pid: rep.pid || ''
    })
    
  }).finally(() => {
    tableLoad.value = false
  })
}

const upLogoEle = ref()
const exceedHandle = (files: File[]) => {
  upLogoEle.value!.clearFiles()
  const file: any = files[0]
  file.uid = genFileId()
  upLogoEle.value!.handleStart(file)
}

const upInvoiceEle = ref()
const exceedInvHandle = (files: File[]) => {
  upInvoiceEle.value!.clearFiles()
  const file: any = files[0]
  file.uid = genFileId()
  upInvoiceEle.value!.handleStart(file)
}

const upLicenseoiceEle = ref()
const exceedLicenseHandle = (files: File[]) => {
  upLicenseoiceEle.value!.clearFiles()
  const file: any = files[0]
  file.uid = genFileId()
  upLicenseoiceEle.value!.handleStart(file)
}

const submitModify = () => {
  baseInfoEle.value.validate().then((valid: boolean) => {
    if(!valid) return Promise.reject();
    tableLoad.value = true

    baseInfoForm.logo = baseInfoForm.logoFiles[0]?.raw
    baseInfoForm.invoiceInfoFile = baseInfoForm.invoiceFile[0]?.raw
    baseInfoForm.businessLicenseFile = baseInfoForm.licenseFile[0]?.raw

    const form: any = new FormData()
    for(const key in baseInfoForm){
      if(['logoFiles', 'invoiceFile', 'licenseFile'].includes(key)) continue;
      form.append(key, baseInfoForm[key])
    }


    companiesPatchApi(form).then(() => {
      tableLoad.value = false
      ElMessage.success('修改成功')
      initCompany()
    }).finally(() => {
      tableLoad.value = false
    })
  })
  
  // companiesPatchApi()
}

// 下载营业执照或开票资料
const downloadFileHandle = (fileId: string, filename: string) => {
  exportHandle(download_fileApi, {fileId: fileId, filename: filename}).then(() => {
    ElMessage.success('下载成功')
  }).catch(() => {
    ElMessage.error('下载错误')
  })

}

// ---------------公司英文名模块---------------
const enNameTbData = ref<CompanyEnRow[]>([])
const searchEnNameHandle = () => {
  tableLoad.value = true
  companiesEn_nameApi({id: currentCpyId.value}).then((rep: CompanyEnRow[]) => {
    enNameTbData.value = rep
  }).finally(() => {
    tableLoad.value = false
  })
}
searchEnNameHandle()

// 修改公司英文名
const editCompanyObj = reactive({
  id: '',
  enName: '',
  companyId: '',
  enabled: true
})
const isShowEidtEnName = ref<boolean>(false)
const editEnNameHandle = (row: CompanyEnRow) => {
  isShowEidtEnName.value = true
  const {enName, companyId, id, enabled} = row
  Object.assign(editCompanyObj, {enName, companyId, id, enabled})
}

const submitEditEnName = () => {
  if(!editCompanyObj.enName.trim()){
    ElMessage.warning('请输入公司英文名')
    return
  }
  companiesEncreateApi(editCompanyObj).then(() => {
    ElMessage.success('修改成功')
    isShowEidtEnName.value = false
    searchEnNameHandle()

  })
}

// 添加公司英文名
const isShowAddEnName = ref<boolean>(false)
const addCompanyEnObj = reactive({
  companyId: currentCpyId.value,
  enName: '',
  enabled: true
})

const addEnNameHandle = () => {
  if(!addCompanyEnObj.enName.trim()){
    ElMessage.warning('请输入公司英文名')
    return
  }
  companiesEncreateApi(addCompanyEnObj).then(() => {
    ElMessage.success('添加成功')
    isShowAddEnName.value = false
    searchEnNameHandle()

  })
}

// 删除英文名
const delEnNameHandle = (row: {id: number, enName: string}) => {
  ElMessageBox.confirm('是否删除英文名: ' + row.enName, '提示', {type: 'warning'}).then(() => {
    return delEnNamesApi({id: row.id})
  }).then(() => {
    ElMessage.success('删除成功')
    searchEnNameHandle()
  })
}

// ---------------银行账户信息模块---------------
const accountData = ref([])
const searchAccountHandle = () => {
  tableLoad.value = true
  bank_accountsApi({
    id: currentCpyId.value
  }).then((rep) => {
    accountData.value = rep
  }).finally(() => {
    tableLoad.value = false
  })
}
searchAccountHandle()

const editAccountEle = ref()
const isBtnLoad = ref<boolean>(false)
const isShowAccountEdit = ref<boolean>(false)
const isShowAccountFiles = ref<boolean>(false)
let accountFiles = ref([])
const accountObj = reactive({
  id: null,
  companyId: currentCpyId.value,
  companyName: '',
  bankName: '',
  accountInfo: '',
  enabled: true,
  note: '',
  country: '',
  currency: '',
})

// 管理账户文件
const filesTbData = ref([])
let fileRowId = null
const showFilesHandle = (row: any) => {
  isShowAccountFiles.value = true
  filesTbData.value = row.uploadFiles
  fileRowId = row.id
}
const autoUpAccountHandle = (file: any) => {
  const form: any = new FormData()
  form.append('file', file.file)
  form.append('id', fileRowId)
  isBtnLoad.value = true
  bank_accountUploadApi(form).then((rep) => {
    ElMessage.success('上传成功')
    accountFiles.value = []
    filesTbData.value = rep
  }).finally(() => {
    isBtnLoad.value = false
  })
}
const donwalSingleHandle = (row: any) => {
  isBtnLoad.value = true
  exportHandle(bank_accountDownApi, {
    id: fileRowId,
    fileId: row.fileId
  }, {contentType: 'formData'}).then(() => {
    ElMessage.success('下载成功')

  }).finally(() => {
    isBtnLoad.value = false
  })
}
const delSingleHandle = (row: any, index: number) => {
  ElMessageBox.confirm(`请确认是否删除${row.fileName}?`, '提示', {type: 'warning'}).then(() => {
    isBtnLoad.value = true
    return bank_accountDelApi({
      id: fileRowId,
      fileId: row.fileId
    }, {contentType: 'formData'})
  }).then((rep) => {
    ElMessage.success('删除成功')
    // filesTbData.value.splice(index, 1)
    filesTbData.value = rep

  }).finally(() => {
    isBtnLoad.value = false
  })
}

// 编辑
const showEditHandle = (row: any) => {
  isShowAccountEdit.value = true
  nextTick(() => {
    Object.assign(accountObj, row)
  })
}

const submitAccountEdit = () => {
  editAccountEle.value.validate().then((valid: boolean) => {
    if(valid === false) return Promise.reject();
    
    isBtnLoad.value = true
    const form = new FormData()
    form.append('id', accountObj.id)
    form.append('companyId', accountObj.companyId)
    form.append('bankName', accountObj.bankName)
    form.append('accountInfo', accountObj.accountInfo)
    form.append('enabled', accountObj.enabled)
    form.append('note', accountObj.note)
    form.append('currency', accountObj.currency)
    form.append('country', accountObj.country)

    return bank_accountPostApi(form)

  }).then(() => {
    ElMessage.success('编辑成功')
    isBtnLoad.value = false
    isShowAccountEdit.value = false
    searchAccountHandle()
  }).finally(() => {
    isBtnLoad.value = false
  })
}

// 添加
const addAccountEle = ref()
const isShowAccountAdd = ref<boolean>(false)
const showAddHandle = () => {
  isShowAccountAdd.value = true
  accountObj.id = null
  accountObj.companyName = baseInfoForm.name
}

const submitAccountAdd = () => {
  addAccountEle.value.validate().then((valid: boolean) => {
    if(valid === false) return Promise.reject();
    isBtnLoad.value = true
    const form = new FormData()
    // 添加账户的状态默认有效
    form.append('enabled', true)
    form.append('companyId', accountObj.companyId)
    form.append('bankName', accountObj.bankName)
    form.append('accountInfo', accountObj.accountInfo)
    form.append('note', accountObj.note)
    form.append('country', accountObj.country)
    form.append('currency', accountObj.currency)
    /* for (let index = 0; index < accountObj.files.length; index++) {
      form.append('files', accountObj.files[index].raw)
    } */
    return bank_accountPostApi(form)
  }).then(() => {
    ElMessage.success('添加成功')
    isShowAccountAdd.value = false
    isBtnLoad.value = false
    searchAccountHandle()
  }).catch(() => {
    isBtnLoad.value = false
  })
}
// 删除
const delAccouontHandle = (row: any) => {
  ElMessageBox.confirm('请确认是否删除:' + row.bankName, '提示', {type: 'warning'}).then(() => {
    tableLoad.value = true
    return bank_accountsDelApi({id: row.id})
  }).then(() => {
    ElMessage.success('删除成功')
    tableLoad.value = false
    searchAccountHandle()
  }).finally(() => {
    tableLoad.value = false
  })
}

// 设为默认
const setDefHandle = (row: {id: number}) => {
  tableLoad.value = true
  priorityApi({
    id: row.id,
    companyId: currentCpyId.value
  }, {contentType: 'formData'}).then(() => {
    ElMessage.success('设置默认成功')
    tableLoad.value = false
    searchAccountHandle()
  }).finally(() => {
    tableLoad.value = false
  })
}

// 自定义排序
const sortVisiable=ref(false)
const sortData=ref([])
const saveSortLoading=ref(false)
const sortHandle=()=>{
  sortData.value=JSON.parse(JSON.stringify(accountData.value))
  sortVisiable.value=true
}
const sortPosition=(row:any,index:any,postion:string)=>{
  let index1:number=postion=='down'?index:index-1
  let index2:number=postion=='down'?index+1:index
  sortData.value[index1] = sortData.value.splice(index2, 1, sortData.value[index1])[0]
}
const saveSort=()=>{
  saveSortLoading.value=true
  let params={
    companyId:currentCpyId.value,
    sortIds:sortData.value.map((el:any)=>el.id)
  }
  bankAccountSortApi(params).then(()=>{
    ElMessage.success('操作成功')
    sortVisiable.value=false
    searchAccountHandle()
  }).finally(()=>{
    saveSortLoading.value=false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({path: '/companies-maintain'}))),
      type: "info",
      class: "mt-10",
      icon: "back"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_el_tabs, {
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((activeName).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "基本信息",
          name: "baseInfo"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_form, {
              model: _unref(baseInfoForm),
              inline: true,
              "label-position": "top",
              ref_key: "baseInfoEle",
              ref: baseInfoEle
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "公司名称:",
                  prop: "name",
                  rules: [{ required: true, message: '请输入公司名称', trigger: 'change' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(baseInfoForm).name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(baseInfoForm).name) = $event)),
                      class: "form-input",
                      placeholder: "请输入公司名称",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公司简称:",
                  prop: "alias"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(baseInfoForm).alias,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(baseInfoForm).alias) = $event)),
                      class: "form-input",
                      placeholder: "请输入公司简称",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "本地最低标准:",
                  prop: "minStandard",
                  rules: [{ required: true, message: '请输入本地最低标准', trigger: 'change' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      controls: false,
                      modelValue: _unref(baseInfoForm).minStandard,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(baseInfoForm).minStandard) = $event)),
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "排序:",
                  prop: "sort"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      controls: false,
                      modelValue: _unref(baseInfoForm).sort,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(baseInfoForm).sort) = $event)),
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "国内外:",
                  prop: "domestic"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(baseInfoForm).domestic,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(baseInfoForm).domestic) = $event)),
                      placeholder: "请选择国内外"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "国内",
                          value: true
                        }),
                        _createVNode(_component_el_option, {
                          label: "国外",
                          value: false
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "状态:",
                  prop: "status"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(baseInfoForm).status,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(baseInfoForm).status) = $event)),
                      placeholder: "请选择状态"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "正常",
                          value: "正常"
                        }),
                        _createVNode(_component_el_option, {
                          label: "注销",
                          value: "注销"
                        }),
                        _createVNode(_component_el_option, {
                          label: "体系外",
                          value: "体系外"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "母公司:",
                  prop: "pid"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(baseInfoForm).pid,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(baseInfoForm).pid) = $event)),
                      clearable: "",
                      placeholder: "请选择母公司",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            label: group.label,
                            key: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: comp.name,
                                  value: comp.id,
                                  key: comp.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "账簿编码:",
                  prop: "accountBookCode"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(baseInfoForm).accountBookCode,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(baseInfoForm).accountBookCode) = $event)),
                      class: "form-input",
                      placeholder: "请输入账簿编码",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公司编码:",
                  prop: "companyCode"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(baseInfoForm).companyCode,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(baseInfoForm).companyCode) = $event)),
                      class: "form-input",
                      placeholder: "请输入公司编码",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "电话:",
                  prop: "telephone"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(baseInfoForm).telephone,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(baseInfoForm).telephone) = $event)),
                      class: "form-input",
                      placeholder: "请输入电话",
                      clearable: "",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "开户银行:",
                  prop: "bankName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(baseInfoForm).bankName,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(baseInfoForm).bankName) = $event)),
                      class: "form-input",
                      placeholder: "请输入开户银行",
                      clearable: "",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "银行账号:",
                  prop: "bankAccount"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(baseInfoForm).bankAccount,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(baseInfoForm).bankAccount) = $event)),
                      class: "form-input",
                      placeholder: "请输入银行账号",
                      clearable: "",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "注册地址:",
                  prop: "registeredAddress"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      autosize: "",
                      style: {"width":"472px"},
                      modelValue: _unref(baseInfoForm).registeredAddress,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(baseInfoForm).registeredAddress) = $event)),
                      class: "form-input",
                      placeholder: "请输入注册地址",
                      maxlength: "500",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "英文地址:",
                  prop: "registeredAddressAlias"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      autosize: "",
                      style: {"width":"472px"},
                      modelValue: _unref(baseInfoForm).registeredAddressAlias,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(baseInfoForm).registeredAddressAlias) = $event)),
                      class: "form-input",
                      placeholder: "请输入英文地址",
                      maxlength: "500",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_divider),
                _createVNode(_component_el_form_item, {
                  label: "公司logo:",
                  prop: "logoFiles"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      ref_key: "upLogoEle",
                      ref: upLogoEle,
                      "file-list": _unref(baseInfoForm).logoFiles,
                      "onUpdate:file-list": _cache[15] || (_cache[15] = ($event: any) => ((_unref(baseInfoForm).logoFiles) = $event)),
                      "list-type": "picture",
                      "auto-upload": false,
                      limit: 1,
                      "on-exceed": exceedHandle,
                      style: {"width":"300px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, null, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["file-list"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_divider),
                _createVNode(_component_el_form_item, {
                  label: "开票资料:",
                  prop: "invoiceInfoFile"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      ref_key: "upInvoiceEle",
                      ref: upInvoiceEle,
                      "file-list": _unref(baseInfoForm).invoiceFile,
                      "onUpdate:file-list": _cache[17] || (_cache[17] = ($event: any) => ((_unref(baseInfoForm).invoiceFile) = $event)),
                      "auto-upload": false,
                      limit: 1,
                      "on-exceed": exceedInvHandle,
                      style: {"width":"300px"}
                    }, {
                      tip: _withCtx(() => [
                        (_unref(baseInfoForm).invoiceInfoFile)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (downloadFileHandle(_unref(baseInfoForm).invoiceInfoFile, _unref(baseInfoForm).invoiceInfoFileName))),
                              class: "ml-10",
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, null, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["file-list"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_divider),
                _createVNode(_component_el_form_item, {
                  label: "营业执照:",
                  prop: "businessLicenseFile"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      ref_key: "upLicenseoiceEle",
                      ref: upLicenseoiceEle,
                      "file-list": _unref(baseInfoForm).licenseFile,
                      "onUpdate:file-list": _cache[19] || (_cache[19] = ($event: any) => ((_unref(baseInfoForm).licenseFile) = $event)),
                      "auto-upload": false,
                      limit: 1,
                      "on-exceed": exceedLicenseHandle,
                      style: {"width":"300px"}
                    }, {
                      tip: _withCtx(() => [
                        (_unref(baseInfoForm).businessLicenseFile)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (downloadFileHandle(_unref(baseInfoForm).businessLicenseFile, _unref(baseInfoForm).businessLicenseFileName))),
                              class: "ml-10",
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, null, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["file-list"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])), [
              [_directive_loading, tableLoad.value]
            ]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (submitModify())),
              disabled: tableLoad.value
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "英文名称",
          name: "enName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (isShowAddEnName.value = true, _unref(addCompanyEnObj).enName = ''))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              icon: "refresh",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (searchEnNameHandle())),
              type: "info"
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              border: "",
              data: enNameTbData.value,
              style: {"width":"800px"},
              class: "mt-10"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "序号",
                  type: "index",
                  width: "70"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "enName",
                  label: "公司英文名称",
                  width: "450"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "enabled",
                  label: "状态",
                  width: "120"
                }, {
                  default: _withCtx(({row}) => [
                    (row.enabled === true)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (row.enabled !== true)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 1,
                          type: "info"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "操作" }, {
                  default: _withCtx(({row}) => [
                    _createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (editEnNameHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_link, {
                          type: "danger",
                          onClick: ($event: any) => (delEnNameHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, tableLoad.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "银行账户信息",
          name: "account"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              disabled: tableLoad.value,
              type: "primary",
              onClick: showAddHandle
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              disabled: tableLoad.value,
              onClick: sortHandle
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              disabled: tableLoad.value,
              icon: "refresh",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (searchAccountHandle())),
              type: "info"
            }, null, 8, ["disabled"]),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              border: "",
              data: accountData.value,
              class: "mt-10"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  label: "序号",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  label: "公司名称",
                  prop: "companyName",
                  width: "110",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "银行名称",
                  prop: "bankName",
                  "show-overflow-tooltip": "",
                  width: "110"
                }),
                _createVNode(_component_el_table_column, {
                  label: "国别",
                  prop: "country",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  label: "币别",
                  prop: "currency",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  label: "账户信息",
                  prop: "accountInfo",
                  "min-width": "350"
                }, {
                  default: _withCtx(({row}) => [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(row.accountInfo), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "账户状态",
                  prop: "enabled",
                  width: "135"
                }, {
                  default: _withCtx(({row}) => [
                    (row.enabled === true)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (row.enabled !== true)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 1,
                          type: "info"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (row.priority !== false)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 2,
                          class: "ml-10"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "文件(pdf)",
                  prop: "uploadFiles",
                  "show-overflow-tooltip": "",
                  width: "100"
                }, {
                  default: _withCtx(({row}) => [
                    _createVNode(_component_el_link, {
                      onClick: ($event: any) => (showFilesHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("(" + _toDisplayString(row.uploadFiles?.length || 0) + ")管理", 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "备注",
                  prop: "note",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "170"
                }, {
                  default: _withCtx(({row}) => [
                    _createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (showEditHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_link, {
                          type: "danger",
                          onClick: ($event: any) => (delAccouontHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_20
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        (row.priority === false)
                          ? (_openBlock(), _createBlock(_component_el_link, {
                              key: 0,
                              onClick: ($event: any) => (setDefHandle(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_21
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, tableLoad.value]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "修改英文名",
      modelValue: isShowEidtEnName.value,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((isShowEidtEnName).value = $event)),
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[27] || (_cache[27] = ($event: any) => (isShowEidtEnName.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitEditEnName
        }, {
          default: _withCtx(() => [
            _hoisted_23
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(editCompanyObj),
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "公司英文名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(editCompanyObj).enName,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(editCompanyObj).enName) = $event)),
                  placeholder: "请输入公司英文名",
                  clearable: "",
                  maxlength: "200"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(editCompanyObj).enabled,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(editCompanyObj).enabled) = $event)),
                  placeholder: "请选择状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "有效",
                      value: true
                    }),
                    _createVNode(_component_el_option, {
                      label: "禁用",
                      value: false
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "添加英文名",
      modelValue: isShowAddEnName.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((isShowAddEnName).value = $event)),
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[30] || (_cache[30] = ($event: any) => (isShowAddEnName.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: addEnNameHandle
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _unref(addCompanyEnObj).enName,
          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(addCompanyEnObj).enName) = $event)),
          placeholder: "请输入公司英文名",
          clearable: "",
          maxlength: "200"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "修改账户信息",
      modelValue: isShowAccountEdit.value,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((isShowAccountEdit).value = $event)),
      width: "600px",
      onClose: _cache[42] || (_cache[42] = ($event: any) => (editAccountEle.value.resetFields(), _unref(accountObj).files = []))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[39] || (_cache[39] = ($event: any) => (isShowAccountEdit.value = false)),
          disabled: isBtnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[40] || (_cache[40] = ($event: any) => ( submitAccountEdit())),
          loading: isBtnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_27
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(accountObj),
          "label-position": "top",
          inline: "",
          ref_key: "editAccountEle",
          ref: editAccountEle,
          disabled: isBtnLoad.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "公司名称",
              prop: "companyName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(accountObj).companyName,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(accountObj).companyName) = $event)),
                  disabled: "",
                  clearable: "",
                  maxlength: "200",
                  class: "form-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "银行名称",
              prop: "bankName",
              rules: [{required: true, message: '请输入银行名称', trigger: 'change'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(accountObj).bankName,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(accountObj).bankName) = $event)),
                  placeholder: "请输入银行名称",
                  clearable: "",
                  maxlength: "200",
                  class: "form-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "国别:",
              prop: "country"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(accountObj).country,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(accountObj).country) = $event)),
                  placeholder: "请选择国别",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countrieList.value, (country) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: country,
                        value: country,
                        key: country
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "币种:",
              prop: "currency"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(accountObj).currency,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(accountObj).currency) = $event)),
                  placeholder: "请选择币种",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currencyOption)(), (currency) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: currency.label,
                        value: currency.id,
                        key: currency.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "账户状态",
              prop: "enabled",
              rules: [{required: true, message: '请选择账户状态', trigger: 'change'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(accountObj).enabled,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(accountObj).enabled) = $event)),
                  placeholder: "请选择状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "有效",
                      value: true
                    }),
                    _createVNode(_component_el_option, {
                      label: "禁用",
                      value: false
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "账户信息",
              prop: "accountInfo",
              rules: [{required: true, message: '请输入账户信息', trigger: 'change'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"480px"},
                  type: "textarea",
                  modelValue: _unref(accountObj).accountInfo,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_unref(accountObj).accountInfo) = $event)),
                  placeholder: "请输入账户信息",
                  clearable: "",
                  maxlength: "2048",
                  rows: 3
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注",
              prop: "note"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"480px"},
                  type: "textarea",
                  modelValue: _unref(accountObj).note,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref(accountObj).note) = $event)),
                  placeholder: "请输入备注",
                  clearable: "",
                  maxlength: "2048",
                  rows: 3
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "添加账户信息",
      modelValue: isShowAccountAdd.value,
      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((isShowAccountAdd).value = $event)),
      width: "600px",
      onClose: _cache[52] || (_cache[52] = ($event: any) => (addAccountEle.value.resetFields(), _unref(accountObj).files = []))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[49] || (_cache[49] = ($event: any) => (isShowAccountAdd.value = false)),
          disabled: isBtnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_28
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[50] || (_cache[50] = ($event: any) => (submitAccountAdd())),
          loading: isBtnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(accountObj),
          "label-position": "top",
          inline: "",
          ref_key: "addAccountEle",
          ref: addAccountEle,
          disabled: isBtnLoad.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "公司名称:",
              prop: "companyName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(accountObj).companyName,
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_unref(accountObj).companyName) = $event)),
                  disabled: "",
                  clearable: "",
                  maxlength: "200",
                  class: "form-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "银行名称:",
              prop: "bankName",
              rules: [{required: true, message: '请输入银行名称', trigger: 'change'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(accountObj).bankName,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_unref(accountObj).bankName) = $event)),
                  placeholder: "请输入银行名称",
                  clearable: "",
                  maxlength: "200",
                  class: "form-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "国别:",
              prop: "country"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(accountObj).country,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_unref(accountObj).country) = $event)),
                  placeholder: "请选择国别",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countrieList.value, (country) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: country,
                        value: country,
                        key: country
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "币种:",
              prop: "currency"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(accountObj).currency,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_unref(accountObj).currency) = $event)),
                  placeholder: "请选择币种",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currencyOption)(), (currency) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: currency.label,
                        value: currency.id,
                        key: currency.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "账户信息:",
              prop: "accountInfo",
              rules: [{required: true, message: '请输入账户信息', trigger: 'change'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"470px"},
                  type: "textarea",
                  modelValue: _unref(accountObj).accountInfo,
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_unref(accountObj).accountInfo) = $event)),
                  placeholder: "请输入账户信息",
                  clearable: "",
                  maxlength: "2048",
                  rows: 4
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注:",
              prop: "note"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"470px"},
                  type: "textarea",
                  modelValue: _unref(accountObj).note,
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_unref(accountObj).note) = $event)),
                  placeholder: " ",
                  clearable: "",
                  maxlength: "2048",
                  rows: 3
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      center: "",
      title: "管理账户文件",
      modelValue: isShowAccountFiles.value,
      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((isShowAccountFiles).value = $event)),
      onClose: _cache[55] || (_cache[55] = ($event: any) => (searchAccountHandle()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          "file-list": _unref(accountFiles),
          "onUpdate:file-list": _cache[53] || (_cache[53] = ($event: any) => (_isRef(accountFiles) ? (accountFiles).value = $event : accountFiles = $event)),
          limite: 1,
          ref: "upload",
          "auto-upload": true,
          "http-request": autoUpAccountHandle
        }, {
          trigger: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: "UploadFilled",
              plain: "",
              disabled: isBtnLoad.value
            }, {
              default: _withCtx(() => [
                _hoisted_30
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["file-list"]),
        _createVNode(_component_el_divider),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: filesTbData.value,
          "max-height": "500px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "序号",
              type: "index",
              width: "70"
            }),
            _createVNode(_component_el_table_column, {
              label: "文件名",
              prop: "fileName"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "130"
            }, {
              default: _withCtx(({ row, $index }) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_link, {
                      onClick: ($event: any) => (donwalSingleHandle(row, $index))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_link, {
                      type: "danger",
                      onClick: ($event: any) => (delSingleHandle(row, $index))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, isBtnLoad.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "自定义排序",
      modelValue: sortVisiable.value,
      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((sortVisiable).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[56] || (_cache[56] = ($event: any) => (sortVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_37
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: saveSortLoading.value,
          onClick: saveSort
        }, {
          default: _withCtx(() => [
            _hoisted_38
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, { data: sortData.value }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "银行名称",
              prop: "bankName"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              prop: "ops",
              width: "120"
            }, {
              default: _withCtx(({row,$index}) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    ($index!=sortData.value.length-1)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          onClick: ($event: any) => (sortPosition(row,$index,'down')),
                          class: "arrow",
                          src: _imports_0,
                          alt: ""
                        }, null, 8, _hoisted_33))
                      : _createCommentVNode("", true),
                    ($index!=0)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          onClick: ($event: any) => (sortPosition(row,$index,'up')),
                          class: "arrow arrow-down",
                          src: _imports_0,
                          alt: ""
                        }, null, 8, _hoisted_34))
                      : _createCommentVNode("", true),
                    ($index==sortData.value.length-1)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                      : _createCommentVNode("", true),
                    ($index==0)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})